import { format } from "lib/globalize-util";
import { getLocalized } from "helpers/transifex/helpers";

export const generateBreadcrumbs = (brandId: string, useTransifex = false) => [
    {
        url: `/brand/${brandId}/admin/brand`,
        title: useTransifex
            ? getLocalized(
                  "brand.admin.promotions.list.breadcrumbs.brand_admin",
                  "PromotionsList - breadcrumbs - Brand Admin",
              )
            : format("Brand Admin"),
    },
    {
        url: `/brand/${brandId}/admin/brand?activeTab=promotions`,
        title: useTransifex
            ? getLocalized(
                  "brand.admin.promotions.list.breadcrumbs.promotions",
                  "PromotionsList - breadcrumbs - Promotions",
              )
            : format("Promotions"),
    },
    {
        url: `/brand/${brandId}/admin/promotions/list`,
        title: useTransifex
            ? getLocalized("brand.admin.promotions.list.breadcrumbs.list", "PromotionsList - breadcrumbs - List")
            : format("List"),
    },
];
